// extracted by mini-css-extract-plugin
export default {"centreAlign":"AdvertisementsList_centreAlign__BXDhi","styleLessButton":"AdvertisementsList_styleLessButton__wNAwT","centeredButton":"AdvertisementsList_centeredButton__l9IA7"};